<template>
  <div
    class="home-camera"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div
      id="home-player"
      v-show="cover"
      :style="{ backgroundImage: playing ? 'none' : `url(${cover})` }"
    ></div>

    <div class="home-camera__name">
      {{ item.name }}
    </div>

    <div class="home-camera-mask" v-if="!playing && !loading">
      <el-button
        circle
        icon="el-icon-caret-right"
        class="center-button"
        v-if="cover"
        @click="readyPlay(item)"
      >
      </el-button>
      <span v-else style="color: red;">设备离线了</span>
    </div>
  </div>
</template>

<script>
import { getCover } from '@/service/camera' // getAddress
import sleep from '@/utlis/sleep'

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    devKey: String,
    token: String,
    item: Object
  },
  data() {
    return {
      loading: false,
      playing: false,
      actived: '',
      cover: '',
      decoder: null
    }
  },
  mounted() {
    this.getActived(this.devKey)
  },
  methods: {
    async getActived(key) {
      if (key) {
        this.loading = true
        const [{ data: cover }] = await Promise.all([getCover(key), sleep(1)])
        this.cover = cover.cover
        this.loading = false
      }
    },
    readyPlay(item) {
      this.$emit('show-player', item)
    }
  },
  watch: {
    devKey(k) {
      this.getActived(k)
    }
  }
}
</script>

<style lang="scss">
.home-camera {
  padding: 20px 4px;
  height: 100%;
  width: 50%;
  box-sizing: border-box;
  position: relative;
  background-color: rgba(0, 0, 0, 0.3);
  &:not(:last-child) {
    border-right: 1px solid #656565;
  }
  #home-player {
    width: 100%;
    height: 100%;
    background-color: #000;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // z-index: 100000;
  }
  .home-camera-mask {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    width: 100%;
    height: 100%;
    user-select: none;
    justify-content: center;
    align-items: center;
    // pointer-events: none;
  }

  .center-button {
    font-size: 1.2rem;
  }
  .home-camera__name {
    position: absolute;
    right: 20px;
    top: 20px;
    color: #fff;
    text-shadow: 0 0 4px #000;
  }
}
</style>
